import { FiltersState } from './pagination'

const storePagingPreferences = (pageSize: number) => {
	if (typeof Storage !== 'undefined') {
		window.localStorage.setItem('pageSize', String(pageSize))
	}
}

const getPagingPreferences = (defaultPageSize?: number): number => {
	if (typeof Storage !== 'undefined') {
		return Number(window.localStorage.getItem('pageSize') || defaultPageSize || 10)
	}

	return defaultPageSize || 10
}

const pageFilter = (filters: FiltersState, index: number) => index < filters.page * filters.pageSize && index >= (filters.page - 1) * filters.pageSize

const calculatePageStart = (filters: FiltersState) => {
	if (filters.page === 1) {
		return filters.page
	}
	return filters.page * filters.pageSize - filters.pageSize + 1
}

const calculatePageTo = (filters: FiltersState, unFilteredRecordsLength: number) => {
	if (filters.page * filters.pageSize < unFilteredRecordsLength) {
		return filters.page * filters.pageSize
	}
	return unFilteredRecordsLength
}

export { calculatePageTo, calculatePageStart, getPagingPreferences, pageFilter, storePagingPreferences }
